import React from 'react';
import parse from 'html-react-parser';
import supportedCurrencies from '../../i18n/supported-currencies_dict.json';
import {localizationHelpers} from './localization.helpers';
import {objectHelpers} from './object.helpers';
import {textHelpers} from './text.helpers';


export const amountHelpers = {
  getAmountBasedOnSeparator: (value, separatorId, showFractionalPart = true) => {
    const parts = Number(value).toFixed(2).toString().split('.');
    let str, separator;
    const integerPart = parts[0];
    const fractionalPart = parts[1];
    switch(separatorId) {
      case 'SID02':
        str = textHelpers.separateString(integerPart, ',');
        separator = '.';
        break;
      case 'SID03':
        str = textHelpers.separateString(integerPart, ' ');
        separator = '.';
        break;
      case 'SID04':
        str = textHelpers.separateString(integerPart, '.');
        separator = ',';
        break;
      case 'SID01':
      default:
        str = textHelpers.separateString(integerPart, ' ');
        separator = ',';
        break;
    }

    return !showFractionalPart && fractionalPart === "00" ? str : `${str}${separator}${fractionalPart}`;
  },

  formatCurrencyAbbreviated: (value) => {
    if (value >= 1e9) return `€${(value / 1e9).toFixed(2)}B`;
    if (value >= 1e6) return `€${(value / 1e6).toFixed(2)}M`;
    if (value >= 1e3) return `€${(value / 1e3).toFixed(2)}K`;
    if (value > 0) value = value.toFixed(2);
    return `€${value.toString()}`;
  },

  getAmountWithCurrencyCode: (value, countryCode = undefined, currencyCode = undefined, showCurrencyCode = true, showFractionalPart = true) => {
    let curCode = 'EUR';
    let separatorId;
    if (currencyCode && !objectHelpers.isNaV(currencyCode)) {
      curCode = currencyCode;
    } else if (countryCode) {
      let country = localizationHelpers.getCountryByCode(countryCode);
      if (country) {
        separatorId = country.separator_id;
        curCode = country.currency_alphabetic_code;
      }
    }
    const cCodeObj = amountHelpers.getCurrencyCode(curCode);
    const cCode = parse(cCodeObj.symbol);
    const priceSymbol = value < 0 ? '-' : '';
    const price = amountHelpers.getAmountBasedOnSeparator(Math.abs(value), separatorId, showFractionalPart);
    if (showCurrencyCode) {
      return cCodeObj.position === 'after' ? <>{priceSymbol}{price}{cCode}</> : <>{priceSymbol}{cCode}{price}</>;
    } else {
      return price;
    }
  },

  getCurrencyCode: (input) => {
    const unknownValue = {currency: input, symbol: input};
    if (!input) return unknownValue;

    const normalizedInput = input.toString().trim().toLowerCase();

    // First: exact match on AlphabeticCode
    for (const code in supportedCurrencies) {
      if (code.toLowerCase() === normalizedInput) {
        return supportedCurrencies[code];
      }
    }

    // Second: exact match on symbol, name, or official name
    for (const code in supportedCurrencies) {
      const currency = supportedCurrencies[code];
      if (
        currency.symbol.toLowerCase() === normalizedInput ||
        currency.name.toLowerCase() === normalizedInput ||
        currency.OfficialName.toLowerCase() === normalizedInput
      ) {
        return currency;
      }
    }

    // Optional: handle prefixed/suffixed symbol (like US$, CAD$, etc.)
    for (const code in supportedCurrencies) {
      const currency = supportedCurrencies[code];
      if (
        normalizedInput.endsWith(currency.symbol.toLowerCase()) &&
        normalizedInput.length > currency.symbol.length
      ) {
        return currency;
      }
    }

    return unknownValue;
  }
}
